import {SET_SEARCH_MEMBER_RESPONSE, CLEAR_SEARCH_MEMBER_RESPONSE} from '../mutation-types';

const initialState = {
  listMemberSearchResponse: null
};

const getters = {
  getListMemberSearchResponse: state => state.listMemberSearchResponse
};

const mutations = {
  [SET_SEARCH_MEMBER_RESPONSE](state, payload) {
    state.listMemberSearchResponse = payload;
  },
  [CLEAR_SEARCH_MEMBER_RESPONSE](state) {
    state.listMemberSearchResponse = null;
  },
};

const actions = {
  setSearchMemberResponse({ commit }, response) {
    commit('SET_SEARCH_MEMBER_RESPONSE', response);
  },
  clearSearchMemberResponse({ commit }) {
    commit('CLEAR_SEARCH_MEMBER_RESPONSE');
  },
};

export default {
  state: initialState,
  getters,
  mutations,
  actions
};
